// extracted by mini-css-extract-plugin
module.exports = {"sv24af8":"sv24af8"};